"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specUnmounted = exports.specParsed = exports.removeSpec = exports.upsertSpec = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.upsertSpec = (0, toolkit_1.createAction)('UPSERT_SPEC');
exports.removeSpec = (0, toolkit_1.createAction)('REMOVE_SPEC');
exports.specParsed = (0, toolkit_1.createAction)('SPEC_PARSED');
exports.specUnmounted = (0, toolkit_1.createAction)('SPEC_UNMOUNTED');
//# sourceMappingURL=specs.js.map